import './styles/global.scss'

import { RefreshApp } from 'components/Account'
import App from 'components/App'
import ErrorBoundary from 'components/ErrorBoundary'
import { store } from 'data/store/configure'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

// TODO: Remove Upgrade to react 18
// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      {window.self === window.top ? (
        <ErrorBoundary fallback={null}>
          <App />
        </ErrorBoundary>
      ) : (
        <RefreshApp />
      )}
    </React.StrictMode>
  </Provider>,
  document.getElementById('root')
)
